module.exports = __webpack_public_path__ + "static/media/Mobile_Carrosel_e_Workshop_COMO_MONTAR_SUA_STARTUP.46b7aa53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Mobile_Carrosel_e_Workshop_COMO_MONTAR_SUA_STARTUP.png
// module id = 51
// module chunks = 0